<template>
  <div class="tabs">
    <div class="tabs--inner">
      <div :class="{'tab':true, 'is-active': activeTab == tab.name}" v-for="tab in tabs" @click="setTab(tab.name)" :key="tab.name" v-if="tab.active !== false">
        <div class="tab--name">
          {{tab.title}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    tabs(){
      return this.$store.state.tabs
    },
    activeTab(){
      return this.$store.state.active_tab
    }
  },
  methods: {
    setTab(name){
      this.$store.commit('SET_ACTIVE_TAB', name)
      this.$emit('change_tab', name)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs{
  display: block;
  background-color: transparent;
  margin-top: -1em;
  @media(min-width: 575px) {
    position: absolute;
    top: -64px;
    left: 0;
  }
  .tabs--inner{
    overflow-x: scroll;
    display: flex;
    justify-content: flex-start;
    padding-bottom: 30px;
  }
  .tab{
    margin: 0 1em;
    align-self: flex-start;
    text-align: center;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    user-select: none;
    color: $ink-dark;
    &:hover{
      border-bottom: 2px solid $sensual;
    }
    &.is-active{
      border-bottom: 2px solid $sensual;
    }
  }

  .tab--name{
    font-size: 1em;
  }
  .tab--fullfilled{
    &.is-inactive{
      opacity: 0.1;
    }
  }

  @include respond-to("small-up") {
    margin-bottom: 0;
    margin-top: 1em;
    max-width: $site-width;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    background: transparent;
    margin-bottom: 0;

    .tabs--inner{
      text-align: center;
      justify-content: flex-start;
      padding-bottom: 30px;
      margin-bottom: 0;
      overflow-x: auto;
    }

    .tab{
      margin: 0 57px 0 0;
      margin-top: 0.2em;
      align-self: flex-start;
      text-align: center;
      background: transparent;
      transition: all 1s ease-in;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      user-select: none;
      color: $ink-dark;
      &:hover{
        border-bottom: 2px solid $sensual;
      }
      &.is-active{
        border-bottom: 2px solid $sensual;
      }
      &:last-child{
        margin-right: 0;
      }
    }

    .tab--fullfilled{
      display: inline-block;
      vertical-align: bottom;
      color: lighten($color-success, 30);
      &.is-inactive{
        color: lighten($header-secondary-color, 30);
        opacity: 0.4;
      }
    }

    .tab--name{
      display: inline-block;
      line-height: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Tabs.vue?592343f2